var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShootproofCrop = function SvgShootproofCrop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,6.298v-4.04C0,1.254,1.004,0,2.257,0h4.041L4.543,1.756H2.257c-0.249,0-0.501,0.25-0.501,0.502v2.284L0,6.298z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.298,15.956H2.257C1.254,15.956,0,14.952,0,13.697V9.658l1.756,1.756v2.284c0,0.252,0.252,0.503,0.501,0.503h2.286 L6.298,15.956z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,9.658v4.039c0,1.004-1.003,2.258-2.257,2.258h-4.04l1.754-1.756h2.286c0.251,0,0.501-0.251,0.501-0.503v-2.284 L21,9.658z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.703,0h4.04C19.745,0,21,1.003,21,2.258v4.04l-1.756-1.756V2.258c0-0.253-0.25-0.502-0.501-0.502h-2.286L14.703,0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShootproofCrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f0fb360095048bc24c81cf124e8adcd7.svg";